import React, {useState} from 'react';
import {Button} from "primereact/button";

import {AppContext} from "../../HomePage";
import {CampaignContext} from "../../App";
import {CampaignService} from "../../service/CampaignService";
import SpecialFieldSetting from "../Admin/SpecialFieldSetting";

const campaignService = new CampaignService();

// Wraps the existing SpecialFieldSetting (which mutates campaign.settings.special_fields
// in place) in a draft campaign + Save, so the onboarding dialog can persist it.
const SpecialFieldsOnboardingStep = ({t, refresh}) => {
    const {toast, setError} = React.useContext(AppContext);
    const {selectedCampaign, loadCampaigns} = React.useContext(CampaignContext);
    const campaignId = selectedCampaign?.id;

    const [saving, setSaving] = useState(false);
    // Draft whose settings.special_fields the embedded component mutates.
    const [draft] = useState(() => ({...selectedCampaign, settings: {...(selectedCampaign?.settings || {})}}));

    const save = () => {
        setSaving(true);
        campaignService.saveCampaignSettings(campaignId, selectedCampaign.use_sale_value, draft.settings).then(() => {
            selectedCampaign.settings = draft.settings;
            if (loadCampaigns) loadCampaigns();
            toast.current.show({severity: 'success', summary: t('campaign.special_field_setting'), detail: t('message_detail.successful')});
            if (refresh) refresh();
        }).catch(error => {
            setError(error);
            setError(null);
        }).finally(() => setSaving(false));
    };

    return (
        <div>
            <small style={{display: 'block', color: '#6b7280', marginBottom: 10}}>
                {t('onboarding.specialFields.hint')}
            </small>
            <SpecialFieldSetting campaign={draft}/>
            <div style={{marginTop: 16, display: 'flex', justifyContent: 'flex-end'}}>
                <Button label={t('actions.save')} icon="pi pi-save" loading={saving} disabled={saving} onClick={save}/>
            </div>
        </div>
    );
};

export default SpecialFieldsOnboardingStep;
